module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAAXNSR0IB2cksfwAAAEtQTFRFAAAASkpQSkpQSkpQSkpQSUlQSkpQSkpRSEhQSkpQS0tRSkpQTExQSkpQSUlQS0tQSkpQUFBQSUlQSkpQSUlRSkpQSkpQSkpQSkpQ/d/VEgAAABl0Uk5TAPDA0O+/f08gMF//QIBQcLAQoK8/b5CfYPQIUkUAAABsSURBVHic7ZE7DoQwDAXNS2wSSDYx//ufdLHEakGipmIqz0iuHjVwnlnaQEbshNn3PQimIWW4DxVXc4oWjm7o4Iv+5NTper79md7wKNJNevQwzbJPCdswpbLAiSKsqHnbXf+ftMHXSDfocJIvSsgDg2bXqpsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-book.png
// module id = 810
// module chunks = 1